@if (extensionGroup) {
  @if (header) {
    <h5>{{ header }}</h5>
  }
  <div class="detail-item">
    <a [routerLink]="['/', extensionGroupRoute, extensionGroup.extensionGroupId]">
      {{ extensionGroup.name }} - {{ extensionGroup.description }}
    </a>
  </div>
}
